"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _ = _interopRequireDefault(require("@carbon/icons-react/lib/arrow--right/24.js"));
var _TagsGroup = _interopRequireDefault(require("../../../TagsGroup/TagsGroup"));
var _SectionTitle = _interopRequireDefault(require("../SectionTitle/SectionTitle"));
var _DownloadLinkBox = _interopRequireDefault(require("../../DownloadLinkBox/DownloadLinkBox"));
var _carbonComponentsReact = require("carbon-components-react");
var _reactRouterDom = require("react-router-dom");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.sia-agenda {\n  text-align: left;\n  width: 100%; }\n  .sia-agenda .row {\n    display: flex;\n    align-items: flex-end;\n    gap: 16px;\n    justify-content: space-between; }\n  .sia-agenda a {\n    text-decoration: none; }\n  .sia-agenda .tags {\n    display: flex;\n    flex-wrap: wrap; }\n  .sia-agenda .topic .title {\n    font-size: 20px; }\n  .sia-agenda .topic .info {\n    display: inline; }\n  .sia-agenda .bx--loading-overlay {\n    position: relative !important;\n    background-color: transparent !important; }\n\n@media (max-width: 66rem) {\n  .sia-agenda .row {\n    flex-direction: column;\n    align-items: flex-start; }\n  .sia-agenda .topic .info {\n    display: inline; } }\n";
  const fileName = "Agenda_Agenda";
  const element = document.querySelector("style[data-sass-component='Agenda_Agenda']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const getFormattedDate = _date => {
  const date = typeof _date === 'object' ? _date[0] : _date;
  const format = date?.split('-');
  if (format?.length !== 3) return '';
  const day = format[2][0] === '0' ? format[2].slice(1) : format[2];
  const month = format[1][0] === '0' ? format[1].slice(1) : format[1];
  const year = format[0];
  return `${day}.${month}.${year}`;
};
const Wrapper = _ref => {
  let {
    content_type,
    onClick,
    lang,
    event_occurrence_code,
    evenito_link,
    children
  } = _ref;
  return content_type == 'event_occurrence' || content_type == 'organisation_event' ? evenito_link?.url ? /*#__PURE__*/_react.default.createElement("a", {
    target: "_blank",
    href: evenito_link?.url
  }, children) : /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    to: `/${lang}/agenda/${event_occurrence_code}`,
    onClick: onClick,
    style: {
      maxWidth: '100%'
    }
  }, children) : /*#__PURE__*/_react.default.createElement("div", null, children);
};
const AgendaItem = _ref2 => {
  let {
    title,
    status,
    status_label,
    organisator,
    date_times,
    isFirst,
    locations,
    lang,
    code,
    content_type,
    evenito_link,
    onClick
  } = _ref2;
  const locationsTags = locations.map(el => ({
    label: el.label,
    type: 'primary'
  }));
  const date = getFormattedDate(date_times?.length > 0 ? date_times[0].date : '');
  if (!title) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: `topic sia-border-01-bottom sia-padding-02-left ${!isFirst ? 'sia-margin-03-top' : ''}`
  }, /*#__PURE__*/_react.default.createElement(Wrapper, {
    content_type: content_type,
    evenito_link: evenito_link,
    onClick: onClick,
    lang: lang,
    event_occurrence_code: code
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "row sia-margin-03-bottom"
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    className: "info sia-margin-01-bottom"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "info sia-text-06 ",
    dangerouslySetInnerHTML: {
      __html: date
    }
  })), /*#__PURE__*/_react.default.createElement("p", {
    className: "title sia-text-04",
    dangerouslySetInnerHTML: {
      __html: title
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "tags sia-margin-01-top"
  }, /*#__PURE__*/_react.default.createElement(_TagsGroup.default, {
    items: [...locationsTags, ...(organisator ? [{
      label: organisator.label,
      type: 'secondary'
    }] : [])]
  }))), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_.default, null)))));
};
const Agenda = _ref3 => {
  let {
    item,
    translate,
    title_background_color,
    lang,
    getAgenda,
    onClick
  } = _ref3;
  const [items, setItems] = (0, _react.useState)([]);
  const [loading, setLoading] = (0, _react.useState)(true);
  (0, _react.useEffect)(() => {
    getAgenda && getAgenda(data => {
      setItems(data.event_occurrences);
      setLoading(false);
    }, item?.events_number);
  }, []);
  const showMoreLink = {
    paragraph_type: 'link_box',
    link: {
      original_url: `/${lang}/agenda`,
      title: translate('cms.homepage.agenda.show_more')
    }
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "sia-agenda"
  }, /*#__PURE__*/_react.default.createElement(_SectionTitle.default, {
    bgColor: title_background_color
  }, translate('cms.homepage.agenda.title')), loading && /*#__PURE__*/_react.default.createElement(_carbonComponentsReact.Loading, null), items.map((item, index) => {
    return /*#__PURE__*/_react.default.createElement(AgendaItem, _extends({
      key: index,
      onClick: onClick,
      isFirst: index === 0,
      lang: lang,
      translate: translate
    }, item));
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "sia-padding-02-left sia-padding-03-top"
  }, /*#__PURE__*/_react.default.createElement(_DownloadLinkBox.default, {
    items: [showMoreLink],
    lang: lang,
    translate: translate,
    isCMS: false
  })));
};
var _default = exports.default = Agenda;